import { render } from "./model.section.html?vue&type=template&id=4184d206&scoped=true&lang=html&external"
import script from "./model.section.vue?vue&type=script&lang=js"
export * from "./model.section.vue?vue&type=script&lang=js"

import "./_model.section.mobile.scss?vue&type=style&index=0&id=4184d206&lang=scss&scoped=true&external"
import "./_model.section.desktop.scss?vue&type=style&index=1&id=4184d206&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4184d206"]])

export default __exports__